import React from "react";
import { ThemeProvider } from "@material-ui/styles";
import { createTheme } from "@material-ui/core/styles";
import grey from "@material-ui/core/colors/grey";
import green from "@material-ui/core/colors/green";
import { useCustomThemeContext } from "./custom-theme-provider";

export const getMaterialUITheme = (customTheme = {}) => {
  return createTheme({
    typography: {
      fontFamily: '"Source Sans Pro", "Roboto", "Arial", sans-serif',
      fontSize: 14,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 500,
    },
    sizes: [4, 8, 12, 16, 24, 32, 48, 64, 96, 128, 192, 256, 384, 512, 640, 768],
    textSizes: [12, 14, 16, 18, 20, 24, 30, 36, 48, 60, 72],
    palette: {
      userPrimary: customTheme.primaryColor,
      userSecondary: customTheme.secondaryColor,
      primary: {
        light: grey[300],
        main: "#1d1d1b",
        dark: "black",
      },
      secondary: {
        light: "#e406131c",
        main: "#e30613",
        dark: "#b11c25",
      },
      disabled: {
        light: "#e7ebec",
        main: "#607d8b",
        dark: "#263238",
      },
      shadow: {
        light: "#d1d3d770",
        main: "rgba(0, 0, 0, 0.23)",
        dark: "rgba(0, 0, 0, 0.87)",
      },
      success: {
        light: green[300],
        main: green[700],
        dark: green[700],
      },
      warning: {
        light: "#e6b933",
        main: "#e0a800",
        dark: "#9c7500",
      },
      white: {
        light: "#ffffff",
        main: "#ffffff",
        dark: "#ffffff",
      },
      link: {
        light: "#3f51b5",
        main: "#3f51b5",
        dark: "#3f51b5",
      },
      blue: {
        light: "#eaf6ff",
        main: "#2196f3",
        dark: "#0069c5",
        disabled: "#0169c55e",
      },
      purple: {
        light: "#d1c4e9",
        main: "#673ab7",
        dark: "#4527a0",
      },
    },
    overrides: {
      MuiTableRow: {
        root: {
          "&$hover:hover": {
            backgroundColor: "#D1D3D7",
          },
          "&:hover *": {
            color: "rgba(0, 0, 0, 0.87)",
          },
        },
      },
      MuiTableCell: {
        root: {
          borderBottom: "1px solid #b5acac66 !important",
        },
      },
      MuiMenuItem: {
        root: {
          lineHeight: 2.5,
        },
      },
    },
  });
};

const MuiThemeProvider = ({ children }) => {
  const { customTheme } = useCustomThemeContext();
  return <ThemeProvider theme={getMaterialUITheme(customTheme.uiTheme)}>{children}</ThemeProvider>;
};

export default MuiThemeProvider;
